const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the invite code Directive which defines the sign in form behavior and markup
 * @argument {Invitations} Invitations injected to access the Invitations resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('inviteCode', ['Invitations', 'Application', '$translate', function (Invitations, Application, $translate) {
  return {
    restrict: 'E',
    template: require('../../../templates/directives/preauth/invite-code.html'),
    controller: function () {
      var self = this;
      self.credentials = {email: ''};
      self.loading = false;

      self.findCode = function () {
        var domain = Application.companyDomain;
        self.loading = true;
        Invitations.openFind({
          domain: domain,
          authtoken: 'public',
          email: self.credentials.email,
          fields: 'email,first_name,last_name,token'
        }, function(data) {
          if (!data || !data.length || !data[0].token) {
            self.noToken = true;
            self.loading = false;
            Application.messaging.addMessage({type: 'error', text: self.translations['preauth.invitecode.noToken']});
            return;
          }
          Application.navigation.goTo('/acceptinvite', {invite_code: data[0].token});
        }, function(err) {
          self.loading = false;
          console.log('error finding the token.')
        });
      };

      $translate(['preauth.invitecode.noToken']).then(function(translations){
        self.translations = translations;
      });

    },
    controllerAs: 'findInvite'
  };
}]);
